import { createClient, HttpError } from "@/http/lib";
import { apiBaseUrl } from "../config";

export const firmwareUpgrade = createClient({
  baseURL: apiBaseUrl,
});

firmwareUpgrade.interceptors.request.use(
  (config) => {
    const app = firmwareUpgrade.getVueInstance();
    const store = app.config.globalProperties.$store;
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = store.getters["user/token"];
    return config.headers.Authorization ? config : Promise.reject(config);
  },
  (error) => Promise.reject(new HttpError(error))
);

firmwareUpgrade.interceptors.response.use(
  (response) => {
    const app = firmwareUpgrade.getVueInstance();
    const store = app.config.globalProperties.$store;
    if (!store.getters["firmware/isCancelClick"]) {
      store.dispatch("firmware/setFirmwareUpgradeTimer");
    }

    return response;
  },
  (error) => {
    const app = firmwareUpgrade.getVueInstance();
    const store = app.config.globalProperties.$store;
    if (!store.getters["firmware/isCancelClick"]) {
      store.dispatch("firmware/setFirmwareUpgradeTimer");
    }
    return Promise.reject(new HttpError(error));
  }
);
